import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

function OtpInput({ label, classInput, length, onComplete, onChange, handleSubmit }) {
  // Validate length is a positive integer
  const validLength = parseInt(length, 10);
  const safeLength = (!validLength || validLength <= 0 || !Number.isInteger(validLength)) ? 4 : validLength;
  
  const inputRef = useRef(Array(safeLength).fill(null));

  const [Otp, setOtp] = useState(Array(safeLength).fill(""));

  const emitChange = (digits) => {
    onChange(digits.join(""));
  };

  const handleTextChange = (input, index) => {
    const newPin = [...Otp];
    newPin[index] = input;
    setOtp(newPin);
    emitChange(newPin);

    if (input.length === 1 && index < safeLength - 1) {
      const inputField = inputRef.current[index + 1];
      if (inputField) {
        inputField.focus();
      }
    }

    if (input.length === 0 && index > 0) {
      const inputField = inputRef.current[index - 1];
      if (inputField) {
        inputField.focus();
      }
    }

    if (newPin.every(digit => digit !== "")) {
      onComplete(newPin.join(""));
    }
  };

  function onSubmit() {
    if (Otp.every(digit => digit !== "")) {
      onComplete(Otp.join(""));
      setTimeout(() => {        
        handleSubmit();
      }, 300)     
    }
  }

  useEffect(() => {   
    onSubmit();
  }, [Otp]);

  const handleOnPaste = (e) => {
    const clipData = e.clipboardData.getData("text/plain").split("");

    const newPin = [...Otp];
    for (let i = 0; i < safeLength; i += 1) {
      newPin[i] = clipData.shift() || '';
    }
    setOtp(newPin);
    emitChange(newPin);
  }

  const handleInputChange = (e, index) => {
    const { value } = e.target;
    
    // Handle iOS Chrome auto-fill: if full code is pasted into first field
    if (index === 0 && value.length === safeLength) {
      const digits = value.split('');
      const newPin = [...Otp];
      
      for (let i = 0; i < safeLength; i += 1) {
        newPin[i] = digits[i] || '';
      }
      
      setOtp(newPin);
      emitChange(newPin);
      
      // Focus the last field after auto-fill
      const lastField = inputRef.current[safeLength - 1];
      if (lastField) {
        lastField.focus();
      }
      
      return;
    }
    
    // Regular single character input
    handleTextChange(value, index);
  }

  return (
    <>
      <div className="flex flex-col gap-7 items-center font-montserratBold">
        <h4 className="text-white text-xl leading-6 tracking-[-0.3px]">
          {label}
        </h4>
        <div className="flex gap-4">
          {Array.from(Array(safeLength)).map((data, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={`otp-input-${index}-${safeLength}`}>
              <input                
                maxLength={index === 0 ? safeLength : 1}
                type="text"
                value={Otp[index]}
                onChange={e => handleInputChange(e, index)}
                ref={ref => {
                  inputRef.current[index] = ref;
                }}
                min={0}
                max={9}
                onPaste={handleOnPaste}
                style={{ marginRight: index === safeLength - 1 ? "0" : "10px" }}
                className={`${classInput} w-[66px] h-[66px] border-2 border-light rounded-xl text-[#F6F3F7] hover:border-[#F6F3F7]`}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

OtpInput.propTypes = {
  label: PropTypes.string,
  classInput: PropTypes.string,
  length: PropTypes.number,
  onComplete: PropTypes.func,
  onChange: PropTypes.func,
  handleSubmit: PropTypes.func
};

OtpInput.defaultProps = {
  label: "",
  classInput: "",
  length: 0,
  onComplete: () => {},
  onChange: () => {},
  handleSubmit: () => {}
};

export default OtpInput;
